module.exports = __webpack_public_path__ + "img/5-1.ab4764d9.jpg";